import { RiderTypes } from '@/features/shared/models/RiderType';

export function getIcon(riderType) {
    switch (riderType) {
        case RiderTypes.Cars:
        case RiderTypes.CarsLeftBehind:
            return 'mdi-car';
        case RiderTypes.Cars8m:
        case RiderTypes.Cars10m:
        case RiderTypes.Cars12m:
        case RiderTypes.Cars14m:
        case RiderTypes.Cars17m:
        case RiderTypes.Cars19m:
        case RiderTypes.Cars22m:
        case RiderTypes.CarsMin22m:
            return 'mdi-truck';
        case RiderTypes.Motorcycles:
            return 'mdi-atv';
        default:
            return 'mdi-human-male';
    }
}

export function getIconText(riderType) {
    switch (riderType) {
        case RiderTypes.Cars:
            return '<6';
        case RiderTypes.Cars8m:
            return '6-8';
        case RiderTypes.Cars10m:
            return '8-10';
        case RiderTypes.Cars12m:
            return '10-12.5';
        case RiderTypes.Cars14m:
            return '12.5-14.5';
        case RiderTypes.Cars17m:
            return '14.5-17.5';
        case RiderTypes.Cars19m:
            return '17.5-19.5';
        case RiderTypes.Cars22m:
            return '19.5-22';
        case RiderTypes.CarsMin22m:
            return '>22';
        default:
            return null;
    }
}
